export default "__VITE_ASSET__$Hy5SsBI__"